export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 210,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_tech_no') || '工艺单编号',
    field: 'techNo',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_order_no') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_name') || '工艺单名称',
    field: 'techName',
    width: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_product_line') || '产品线',
    field: 'v_productLine',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_effective_date') || '生效日期',
    field: 'effectiveDate',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_remark') || '工艺单备注说明',
    field: 'techRemark',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_desc') || '工艺要求',
    field: 'technologyDesc',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tolerances_desc') || '公差要求',
    field: 'tolerancesDesc',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_appearance_desc') || '外观要求',
    field: 'surfaceDesc',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_other_desc') || '其他要求',
    field: 'otherDesc',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_State') || '工艺单状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'reviewByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_reviewer_by_name') || '审核人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'reviewTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_reviewer_by_time') || '审核时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
